var exports = {
  "q": "AttachmentSingleMedia.module__relativeWrapper___QTcxQk",
  "u": "AttachmentSingleMedia.module__singleMediaContainer___QTcxQk",
};

module.exports = exports;
